module.exports = __webpack_public_path__ + "static/media/ico-layers.c3655c96.svg";